/*
 * Kyo Energy Crystals - sincroniza la foto seleccionada con la variante.
 * Al cambiar de foto (miniatura, flechas o deslizando), si esa foto es la
 * imagen destacada de una variante, se selecciona esa variante.
 * Solo actua en fichas de producto con mas de una variante. Si algo no
 * cuadra (sin variantes, fotos y galeria distintas, error), no hace nada.
 */
(function () {
  'use strict';
  try {
    var form = document.querySelector('form[data-product-form]');
    var wrapper = document.querySelector('.product__media__wrapper');
    if (!form || !wrapper) return;

    var handle = form.getAttribute('data-product-handle');
    if (!handle) return;

    fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) {
        return r.ok ? r.json() : null;
      })
      .then(function (product) {
        try {
          init(product);
        } catch (e) {
          /* sin efecto */
        }
      })
      .catch(function () {
        /* sin efecto */
      });

    function init(product) {
      if (!product || !product.variants || product.variants.length < 2) return;
      if (!product.media || !product.options) return;

      var cells = wrapper.querySelectorAll('.product__media');
      // Si la galeria no coincide con los medios del producto (p. ej. filtrada), no se toca nada.
      if (!cells.length || cells.length !== product.media.length) return;

      var optionNames = product.options.map(function (o) {
        return typeof o === 'string' ? o : o.name;
      });

      // id de foto -> variante
      var variantByMedia = {};
      product.variants.forEach(function (v) {
        if (v.featured_media && v.featured_media.id != null) {
          variantByMedia[String(v.featured_media.id)] = v;
        }
      });
      if (!Object.keys(variantByMedia).length) return;

      var busy = false;

      function optionInputs(name) {
        var all = document.querySelectorAll('input[type="radio"], select');
        var found = [];
        for (var i = 0; i < all.length; i++) {
          if (all[i].name === 'options[' + name + ']') found.push(all[i]);
        }
        return found;
      }

      function currentValue(name) {
        var inputs = optionInputs(name);
        for (var i = 0; i < inputs.length; i++) {
          var el = inputs[i];
          if (el.tagName === 'SELECT') return el.value;
          if (el.checked) return el.value;
        }
        return null;
      }

      function alreadySelected(variant) {
        for (var i = 0; i < optionNames.length; i++) {
          if (currentValue(optionNames[i]) !== variant.options[i]) return false;
        }
        return true;
      }

      function selectVariant(variant) {
        for (var i = 0; i < optionNames.length; i++) {
          var value = variant.options[i];
          var inputs = optionInputs(optionNames[i]);
          for (var j = 0; j < inputs.length; j++) {
            var el = inputs[j];
            if (el.tagName === 'SELECT') {
              if (el.value !== value) {
                el.value = value;
                el.dispatchEvent(new Event('change', { bubbles: true }));
              }
              break;
            }
            if (el.value === value) {
              if (!el.checked && !el.disabled) el.click();
              break;
            }
          }
        }
      }

      function onSlideChange() {
        if (busy) return;
        var index = -1;
        for (var i = 0; i < cells.length; i++) {
          if (cells[i].classList.contains('is-selected')) {
            index = i;
            break;
          }
        }
        if (index < 0) return;

        var variant = variantByMedia[String(product.media[index].id)];
        if (!variant) return; // foto sin variante asociada: no se cambia nada
        if (alreadySelected(variant)) return;

        busy = true;
        selectVariant(variant);
        setTimeout(function () {
          busy = false;
        }, 400);
      }

      var observer = new MutationObserver(onSlideChange);
      for (var c = 0; c < cells.length; c++) {
        observer.observe(cells[c], { attributes: true, attributeFilter: ['class'] });
      }
    }
  } catch (e) {
    /* sin efecto */
  }
})();
